import { Outlet } from 'react-router-dom';
import Header from './Header/Header';
import Footer from './Footer/Footer';

const Main = () => {
  return (
    <>
      <Header />
      <div id="main-app" className="layout-veritcle-menu">
        <div className="app-body kpi-dahboard-page">
          <Outlet />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Main;
